import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DetailsIcon from '@/svg-icons/details';

function DetailsSection({ details }) {
  const detailEntries = Object.keys(details).map((detail, index) => {
    let value = null;
    if (details[detail] === null || details[detail] === '' || detail === 'price') {
      return null;
    }
    switch (detail) {
      case 'area':
        value = `${details[detail]} m²`;
        break;
      case 'furnished':
      case 'building_type':
        value = <FormattedMessage id={details[detail]} />;
        break;
      default:
        value = details[detail];
        break;
    }
    return (
      <div key={index} className="w-1/2 mb-[1vw]">
        <div className="font-bold">
          <FormattedMessage id={detail} />
        </div>
        {value}
      </div>
    );
  });

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <DetailsIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="details_title" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]" data-cy="order-details-section">
        {detailEntries}
      </div>
    </div>
  );
}

DetailsSection.propTypes = {
  details: PropTypes.object.isRequired,
};

export default DetailsSection;
